import { render, staticRenderFns } from "./card-form.vue?vue&type=template&id=3aaa833e&scoped=true&"
import script from "./card-form.vue?vue&type=script&lang=js&"
export * from "./card-form.vue?vue&type=script&lang=js&"
import style0 from "./card-form.vue?vue&type=style&index=0&id=3aaa833e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaa833e",
  null
  
)

export default component.exports